import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BoucleView from '../views/LoopView.vue'
import ChallengeView from '../views/ChallengeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/challenge/infinity',
    component: HomeView
  },
  {
    path: '/challenge/:challenge_uuid/boucle/:id',
    name: 'BoucleView',
    component: BoucleView,
    meta: {
      title: 'Full Moon Infinity - Résultats boucle'
    }
  },
  {
    path: '/challenge/:challenge_uuid',
    name: 'ChallengeView',
    component: ChallengeView,
    meta: {
      title: 'Full Moon Infinity - Résultats challenge'
    }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Full Moon Infinity';
  next();
});

export default router
